export default __webpack_public_path__ + "static/media/contact-golf.0b8e9c4f.svg";